import { render } from "./CustomCursor.vue?vue&type=template&id=3a6523ae&ts=true"
import script from "./CustomCursor.vue?vue&type=script&lang=ts"
export * from "./CustomCursor.vue?vue&type=script&lang=ts"

import "./CustomCursor.vue?vue&type=style&index=0&id=3a6523ae&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__